import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Slide from '@material-ui/core/Slide';
import Button from '@material-ui/core/Button';

class AlertDialog extends React.Component {
  static propTypes = {
    open: PropTypes.bool,
    showButton: PropTypes.bool,
    showLeftButton: PropTypes.bool
  };

  static defaultProps = {
    open: false,
    showButton: true,
    showLeftButton: true
  };

  constructor(props) {
    super(props);

    this.state = {
      open: props.open
    };
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleConfirm = () => {
    this.props.confirmAction && this.props.confirmAction();
    this.setState({ open: false });
  }

  transition = (props) => {
    return <Slide direction="up" {...props} />;
  }

  render() {
    return (
      <div>
        {
          this.props.showButton &&
            <Button variant={this.props.variant} disabled={this.props.disabled} color={this.props.color} onClick={this.handleClickOpen}>{this.props.icon}{this.props.buttonLabel}</Button>
        }
        <Dialog
          open={this.state.open}
          TransitionComponent={this.transition}
          keepMounted
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title">
            {this.props.title}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {this.props.desc}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            {
              this.props.showLeftButton &&
                <Button onClick={this.handleClose} color="primary">
                  No
                </Button>
            }
            <Button onClick={this.handleConfirm} color="primary">
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default AlertDialog;



// WEBPACK FOOTER //
// ./src/components/AlertDialog/index.js